import React from "react";
import Body from "./Body";
import salariesImg from "../../../../assets/Images/finance/AcademicEx/salaries.png";
import materialImg from "../../../../assets/Images/finance/AcademicEx/material.png";
import transportImg from "../../../../assets/Images/finance/AcademicEx/transport.png";
import labequipImg from "../../../../assets/Images/finance/AcademicEx/lab-equipment.png";
import libraryImg from "../../../../assets/Images/finance/AcademicEx/library.png";
import elearningImg from "../../../../assets/Images/finance/AcademicEx/e-learning.png";
import altImg from "../../../../assets/Images/finance/AcademicEx/exam-material.png";

const AcademicEx = () => {
  const AcademicEx = [
    {
      title: "Salaries",
      description:
        "You can collect academic contributors (Teachers, Non-teaching staffs, and other officials).",
      image: salariesImg,
      link: "/finance/cashoutflow/academicex/salaries",
    },
    {
      title: "Material and Resources",
      description:
        "Record academic materials and resources to track exact data.",
      image: materialImg,
      link: "/finance/cashoutflow/academicex/material-resources",
    },
    {
      title: "Transportation cost",
      description:
        "Track students transportation-related institutional costs efficiently.",
      image: transportImg,
      link: "/finance/cashoutflow/academicex/transport-cost",
    },
    {
      title: "Laboratory equipment",
      description:
        "Track laboratory equipment data and its amount for better managing.",
      image: labequipImg,
      link: "/finance/cashoutflow/academicex/lab-equipment",
    },
    {
      title: "Library resources",
      description:
        "Managing Library cost and records shortage of reading books.",
      image: libraryImg,
      link: "/finance/cashoutflow/academicex/library-resources",
    },
    {
      title: "Technology & E-learning",
      description:
        "If you provide e-learning software as a student add-on educational part.",
      image: elearningImg,
      link: "/finance/cashoutflow/academicex/technology-learning",
    },
    {
      title: "Examination",
      description:
        "The examination materials is generally taking periodic charges.",
      image: altImg,
      link: "/finance/cashoutflow/academicex/examination",
    },
    {
      title: "Academic events",
      description:
        "Track academic event and related institutional academic expenses.",
      image: altImg,
      link: "/finance/cashoutflow/academicex/academic-events",
    },
    {
      title: "Professional development",
      description:
        "Professional development is generally for teachers skill development.",
      image: altImg,
      link: "/finance/cashoutflow/academicex/professional-development",
    },
    {
      title: "Personality development",
      description:
        "Personality development is basically for students mindset, skill etc. growth.",
      image: altImg,
      link: "/finance/cashoutflow/academicex/personality-development",
    },
    {
      title: "Miscellaneous costs",
      description: "If you buy something or keep maintaining something.",
      image: altImg,
      link: "/finance/cashoutflow/academicex/miscellaneous-cost",
    },
  ];
  const _this = { AcademicEx };
  return <Body {..._this} />;
};

export default AcademicEx;
